import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { Band } from "../../types/bands"

interface SpotifyProps {
  band: Band
}

export const Spotify: React.FC<SpotifyProps> = ({ band }) => {
  const fieldData = {
    field: "spotify_url",
    name: "spotifyUrl",
    label: "Your Spotify Url",
    placeholder: "Spotify URL",
    required: false,
    notes:
      "Link your profile to your Spotify page. It should look like: https://open.spotify.com/artist/5MyxZULyqTUV0119j6ocEE",
  }

  return <EditBandFormField type="text" fieldData={fieldData} />
}
